import { OverlayTrigger, Popover, Tooltip } from 'react-bootstrap'
import './styles/index.scss'

/**
 * A custom overlay trigger component that can display either a tooltip or popover
 *
 * @property {Array<string>|string} trigger - Events that trigger the overlay
 * @property {string} placement - Placement of the overlay
 * @property {'tooltip'|'popover'} overlayType - Type of overlay to display
 * @property {string} overlayId - Unique identifier for the overlay
 * @property {string} overlayClassName - CSS class name for the overlay
 * @property {React.ReactNode} overlayContent - Content to display in the overlay
 * @property {React.ReactNode} children - Trigger element
 * @returns {React.ReactElement} CustomOverlayTrigger component
 */
const CustomOverlayTrigger = (props) => {
  const {
    trigger,
    placement,
    overlayType,
    overlayId,
    overlayClassName,
    overlayContent,
    children
  } = props

  /**
   * Renders the tooltip component
   * @param {Object} props - Tooltip props
   * @returns {React.ReactElement} Tooltip component
   */
  const renderTooltip = (props) => (
    <Tooltip id={overlayId} className={overlayClassName} {...props}>
      {overlayContent}
    </Tooltip>
  )

  /**
   * Renders the popover component
   * @returns {React.ReactElement} Popover component
   */
  const renderPopup = () => (
    <Popover id={overlayId} className={overlayClassName} {...props}>
      <Popover.Body>{overlayContent}</Popover.Body>
    </Popover>
  )

  return (
    <OverlayTrigger
      trigger={trigger}
      placement={placement}
      overlay={overlayType === 'tooltip' ? renderTooltip : renderPopup}
    >
      {children}
    </OverlayTrigger>
  )
}

export default CustomOverlayTrigger
